var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { jsx as _jsx } from "react/jsx-runtime";
import { useQueryClient } from '@tanstack/react-query';
import { useCallback, useEffect } from 'react';
import { BadRequestError } from '@lucidlink/sdk/fetcher';
import { Button, hardReload, Trans, translate, useToastService, } from '@lucidlink/uicore';
import { UPGRADE_REQUIRED_ERROR_CODE } from '@lucidlink/workspacemanagement';
export const useUpgradeRequired = () => {
    _react_refresh_temp_1();
    const queryClient = useQueryClient();
    const { addToast, removeToast } = useToastService();
    const handleUpgradeRequiredError = useCallback(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- Type comes from ReactQuery
    (error) => {
        if (error instanceof BadRequestError &&
            error.errors.some((err) => err.code === UPGRADE_REQUIRED_ERROR_CODE)) {
            removeToast('upgrade-required');
            addToast({
                content: {
                    message: translate('To complete this action you need to refresh your browser.'),
                },
                kind: 'negative',
                'data-testid': 'upgrade-required',
                id: 'upgrade-required',
                hasCloseButton: true,
                dismissTempo: 'never',
                actionComponent: (_jsx(Button, { "data-testid": "refresh", kind: "ghost", onClick: hardReload, size: "big", children: _jsx(Trans, { children: "Refresh" }) })),
            });
        }
    }, [addToast, removeToast]);
    useEffect(() => {
        const unsubscribeQueries = queryClient
            .getQueryCache()
            .subscribe((event) => {
            if (event.type === 'updated' && event.query.state.error) {
                handleUpgradeRequiredError(event.query.state.error);
            }
        });
        const unsubscribeMutations = queryClient
            .getMutationCache()
            .subscribe((event) => {
            if (event.type === 'updated' && event.mutation.state.error) {
                handleUpgradeRequiredError(event.mutation.state.error);
            }
        });
        return () => {
            unsubscribeQueries();
            unsubscribeMutations();
        };
    }, [queryClient, handleUpgradeRequiredError]);
};
_react_refresh_temp_1(useUpgradeRequired, "f7LcOwJ3uR5JGfk4Pv3n8TMjw1w=", false, () => [useQueryClient, useToastService]);
